import getCookie from '@helpers/getCookie';
import ApiRoot from '@http/ApiRoot';
import BetModel from '@models/BetModel';

export default async function (options) {
  const parsedOptions = {
    productID: options.productID || null,
    drawNumber: options.drawNumber || null,
    lotteryID: options.lotteryID || null,
    pageNumber: options.page || 1,
    pageSize: options.pageSize || 10,
    onlyPrized: options.onlyPrized || false,
    categoryID: options.categoryID || 1,
    betNumber: options.betNumber || null,
    isOrdered: options.isOrdered || false
  }

  if (!parsedOptions.lotteryID) {
    return new Error('Lottery ID é requerido')
  }

  try {
    const data = await ((!parsedOptions.isOrdered && parsedOptions.categoryID === 2)
      ? ApiRoot.get('mycards', {
        params: {
          shoppingCartID: getCookie('cart') || null,
          drawNumber: parsedOptions.drawNumber,
          lotteryID: parsedOptions.lotteryID,
          pageNumber: parsedOptions.pageNumber,
          pageSize: parsedOptions.pageSize,
          betNumber: parsedOptions.betNumber
        }
      })
      : ApiRoot.get('cards', {
        params: {
          productID: parsedOptions.productID,
          pageNumber: parsedOptions.pageNumber,
          pageSize: parsedOptions.pageSize,
          onlyPrized: options.onlyPrized,
          betNumber: parsedOptions.betNumber,
          drawNumber: parsedOptions.drawNumber
        }
      }));

    if (!data || !data.cards) {
      return null
    }

    data.cards = data.cards.map((a) => new BetModel(a, parsedOptions.lotteryID))
    return data;
  } catch (err) {
    console.error(err)
    return new Error(err);
  }
}
